/**
 * Created by Claude on 21/01/2026.
 * 编辑 MQTT 配置成功后的提示弹窗
 */
import React from 'react';
import { Modal } from 'antd';
import i18n from 'i18next';
import Styles from './css/EditConfigTipModal.module.scss';

function EditConfigTipModal({ visible, onOk, configName }) {
  return (
    <Modal
      width={480}
      title={i18n.t('mqtt_config_modified_title').replace('%$', configName || '')}
      visible={visible}
      onCancel={onOk}
      onOk={onOk}
      okText={i18n.t('i_known')}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <div className={Styles.content}>
        <div className={Styles.attentionSection}>
          <span className={Styles.attentionLabel}>{i18n.t('attention_label')}</span>
          <span className={Styles.warningText}>
            {i18n.t('mqtt_config_modified_warning')}
          </span>
        </div>

        <div className={Styles.instructionList}>
          <div className={Styles.instructionItem}>
            <span className={Styles.stepLabel}>
              {i18n.t('wifi_device_step_label')}
            </span>
            <span className={Styles.stepText}>
              {i18n.t('wifi_device_step_text')}
            </span>
          </div>

          <div className={Styles.instructionItem}>
            <span className={Styles.stepLabel}>
              {i18n.t('nb_iot_device_step_label')}
            </span>
            <span className={Styles.stepText}>
              {i18n.t('nb_iot_device_step_text')}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default EditConfigTipModal;
